import React, { useState, useEffect } from 'react';
import { FiFileText } from 'react-icons/fi';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { Loader } from '@/components/custom/loader';
// import { EmptyState } from '@/components/custom/empty-state';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardBodyHeaderContent, CardFooter, CardHeader, CardIcon, CardTitle, CardWrapper } from '@/components/ui/card';
// import { BadgeTruncate } from '@/components/ui/badge';

export function CourseClassroomFiles(props) {
  const { t } = useTranslation();
  const { selectedItemId } = props;
  const client = useClient();
  const [loading, setLoading] = useState(true);
  const [learnSystemFiles, setLearnSystemFiles] = useState([]);

  const getLearningSystemFiles = async () => {
    setLoading(true);
    const url = `learning_system_files?filter[learning_system_items.id]=${selectedItemId}`;
    const { data, error } = await client.fetch(url);

    setLoading(false);
    if (error) {
      toast.error(t('toast.errorGetMaterials'));
    } else {
      setLearnSystemFiles(data);
    }
  };

  useEffect(() => {
    if (selectedItemId) {
      getLearningSystemFiles();
    }
  }, [selectedItemId]);

  if (loading) {
    return (
      <div className="mb-6">
        <Loader />
      </div>
    );
  }

  return (
    learnSystemFiles.length > 0 && (
      <CardWrapper
        orientation="vertical"
        className="mb-6"
      >
        {learnSystemFiles.length > 0 ? (
          (learnSystemFiles || []).map((document, i) => (
            <Card
              key={i}
              orientation="horizon"
            >
              <CardHeader className="flex-grow">
                <CardBodyHeaderContent className="mb-0">
                  <CardIcon className="p-2">
                    <FiFileText size={16} />
                  </CardIcon>
                  <CardTitle>{document?.title}</CardTitle>
                </CardBodyHeaderContent>
              </CardHeader>

              {/* <CardBody className="self-center">
                  <BadgeTruncate
                    items={document?.taxonomies}
                    oneLine
                  />
                </CardBody> */}

              <CardFooter>
                <Button
                  variant="outline"
                  size="sm"
                  wide
                  asChild
                >
                  <a
                    href={document?.file?.url ? document?.file?.url : document?.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('button.view')}
                  </a>
                </Button>
              </CardFooter>
            </Card>
          ))
        ) : (
          <></>
          // <EmptyState
          //   type="content"
          //   title="Sem conteúdo"
          // />
        )}
      </CardWrapper>
    )
  );
}
